const Objectives = () => {
  const objectives = [
    `تقديم المساعدات النقدية والعينية إلى الأسر والأفراد المحتاجين من الفقراء والمساكين والعجزة والمرضى والمشلولين والمعوقين والأيتام والأرامل والمطلقات وعوائل المسجونين والراغبين في الزواج ومساعدات تحسين المساكين وذلك على ضوء البحث الاجتماعي الميداني.`,
    `إنشاء مؤسسات خيرية ذات أغراض متعددة ومجمعات سكنية لإيواء الفقراء والعجزة والأيتام والأرامل ومن في حكمهم في حدود إمكانيات الجمعية. `,
    ` تقديم خدمات الرعاية الصحية والوقائية والعلاجية وتنمية الوعي الصحي لدى المواطنين ورعاية المسنين والعاجزين ورعاية المعوقين وإعادة تأهيلهم ورعاية المرضى النفسانيين والمتخلفين عقلياً.`,
    `إنشاء مراكــــز للتدريب ومـــدارس لتحفيظ القــرآن الكــــريم ومكتبات خيرية ورياض أطفال ودور حضانة.`,
    `المساهمة مع الجهات المختصة في مساعدة منكوبي الحوادث والكوارث العامة.`,
    `تقديم خدمات عامة في جميع الأغراض الاجتماعية والخيرية.`,
    `المساهمة في جميع النشاطات والأعمال الخيرية في مختلف المجالات بما فيها المساهمة في بناء المساجد وتجهيزها وصيانتها بعد التنسيق مع الجهات المختصة.`,
    `تقوم الجمعية بأعمال استثمارية في حدود إمكانياتها بغرض تنمية مشاريعها وبرامجها الخيرية بعد موافقة وزارة الشؤون الاجتماعية.`,
  ];

  return (
    <article>
      <h2 className="text-[#408099] font-bold text-md md:text-lg lg:text-2xl mb-2 md:mb-4">
        الأهداف
      </h2>
      <p className="mb-4 md:mb-6">
        تقديم الخدمات الاجتماعية والصحية والتعليمية والدينية والثقافية التي
        تحتاجها منطقة خدماتها دون أن يكون هدفها الحصول على الربح المادي، ويمكن
        للجمعية أن تقوم بأعمال استثمارية في حدود إمكانياتها بغرض تنمية مشاريعها
        وبرامجها الخيرية:
      </p>
      <ol>
        {objectives.map((element) => (
          <li className="list-decimal mr-8" key={element}>
            {element}
          </li>
        ))}
      </ol>
    </article>
  );
};

export default Objectives;
